"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

var Number = function Number(props) {
  var value = props.value,
      defaultValue = props.defaultValue,
      min = props.min,
      max = props.max,
      _props$step = props.step,
      step = _props$step === void 0 ? 1 : _props$step,
      onChange = props.onChange;
  return /*#__PURE__*/_react.default.createElement(_antd.InputNumber, {
    min: min,
    max: max,
    step: step,
    defaultValue: value || defaultValue,
    onChange: onChange,
    style: {
      width: '100%'
    }
  });
};

var _default = Number;
exports.default = _default;